// © Microsoft Corporation. All rights reserved.
/**
 * Enum for different page types
 * @enum
 */
export var PageType;
(function (PageType) {
    PageType["Article"] = "article";
    PageType["ArticleFullScreen"] = "articlefullscreen";
    PageType["DHP"] = "dhp";
    PageType["Gallery"] = "gallery";
    PageType["GalleryFullScreen"] = "galleryfullscreen";
    PageType["Launcher"] = "launcher";
    PageType["MMX"] = "mmx";
    PageType["NewsAndInterests"] = "newsandinterestshp";
    PageType["Newsbar"] = "newsbar";
    PageType["NTP"] = "ntp";
    PageType["Story"] = "story";
    PageType["Shopping"] = "shopping";
    PageType["ShoppingProductDetails"] = "shopping::product";
    PageType["ShoppingDealsStoreCategory"] = "shopping::deals::storecategory";
    PageType["Video"] = "video";
    PageType["Windows"] = "windowshp";
    PageType["WindowsShell"] = "shellhp";
})(PageType || (PageType = {}));
/** The AudienceMode enum */
export var AudienceModeType;
(function (AudienceModeType) {
    AudienceModeType["Adult"] = "adult";
    AudienceModeType["Enterprise"] = "enterprise";
    AudienceModeType["Kids"] = "kids";
})(AudienceModeType || (AudienceModeType = {}));
//# sourceMappingURL=PageTypes.js.map